import { PaymentStatusEnum } from '../enums/payment-status.enum';
import { IPointing } from '../interfaces/garderie.interface';

export const mockGarderies: IPointing[] = [
    {
        id: 0,
        date: new Date(2021, 7, 2),
        start: new Date(2021, 7, 2, 8, 0),
        end: new Date(2021, 7, 2, 8, 30),
        duration: 30,
        parentId: 2,
        educationLevelId: 1,
        student: {
            id: 1,
            firstname: 'john',
            lastname: 'doe',
        },
        price: 50,
        parents: [
            {
                id: 2,
                firstname: 'Senior',
                lastname: 'doe',
            },
            {
                id: 3,
                firstname: 'Janette',
                lastname: 'doe',
            },
        ],
        paymentStatus: PaymentStatusEnum.PAID,
    },
];
